<template>
    <div v-if="isRouterReady" :class="['patent-view-app', browserClass]">
        <CompareRoot v-if="isCompareView" :viewParams="viewParams" />
        <FullViewRoot v-else-if="isFullView" />
        <ViewRoot v-else-if="$route.query.patentId" :viewParams="viewParams" />
        <PtPageNotFound v-else class="patent-view-app__not-found" />
    </div>
</template>

<script setup lang="ts">
import { EXTENDS_PARAM_NAME_FOR_PATENT_FAMILY } from '@/subview_plugins/patent-family/constants';
import CompareRoot from '@/views/root/CompareRoot.vue';
import ViewRoot from '@/views/root/ViewRoot.vue';
import FullViewRoot from '@/views/root/FullViewRoot.vue';
import Bowser from 'bowser';
import PtPageNotFound from 'library-@/components/PtPageNotFound.vue';
import { getViewParamsByRoute } from 'library-@/utils/get-params';
import { computed, ref } from 'vue';
import { useRoute, useRouter } from 'vue-router/composables';
import { useCompareUrlState } from '@/composables/use-compare-url-state';
import { usePatentViewUrlParams } from './composables/use-patent-view-url-params';
// @ts-ignore
// window.queryObj = {};

const route = useRoute();
const router = useRouter();

const { isCompareView } = useCompareUrlState();
const { isFullView } = usePatentViewUrlParams();

const viewParams = computed(() => {
    return getViewParamsByRoute(route, {
        /* 忽略 patentFamily 的扩展 query 参数*/
        omits: [EXTENDS_PARAM_NAME_FOR_PATENT_FAMILY],
        /* 将 pf 转为 _familyType 接口需要*/
        trans: [],
    });
});


const isRouterReady = ref(false);

router.onReady(() => isRouterReady.value = true);

const browser = Bowser.getParser(window.navigator.userAgent);
const { name, version } = browser.getBrowser();

const browserClass = [
    `browser-name--${name?.replace(/ /g, '-').toLowerCase()}`,
    `browser-version--${parseInt(version || '', 10)}`,
    `browser-os--${browser.getOSName(true)}`,
];

/* 统计用户的常用窗口尺寸 */
window.rvTrack('User Screen Size', { height: window.innerHeight, width: window.innerWidth });
</script>

<style lang="scss">
html, body {
    font-family: Noto Sans SC,Source Han Sans CN,Source Han Sans SC,-apple-system,PingFang SC,Helvetica Neue,Helvetica,Hiragino Sans GB,Microsoft YaHei,ST Heiti,SimHei,Arial,sans-serif !important;
}

.patent-view-app {
    position: relative;
    font-size: 14px;
    .modal-mask {
        // 和 src/components/chemical-panel/Draggable.vue 的 dragableZindexManager 关系到
        // 1000-1049 为Draggable占用 飞行高度区间
        z-index: 1050;
    }
}

.snap-auto-complete .form-control .users-input {
    padding-top: 0 !important;
}
.snap-auto-complete .form-control .users-input .placeholder {
    line-height: 32px !important;
}
*:focus {
    outline: none !important;
}

.zen-tips-hover {
    box-shadow: 0 2px 10px 0 rgba(0, 0, 0, 0.3);
}

//FIXME: 这个样式修复了 TOC-7352，but dirty
.pt-section-title {
    p {
        display: inline !important;
    }
}

.thum-image-container {
    position: relative;
}


.dual-figures_tip {
    position: absolute;
    top: -300px;
    padding: 0;
    z-index: 9;
    > span { padding: 0 8px; line-height: 24px;}
    button {
        border-radius: 4px;
        cursor: pointer;
        background: none;
        padding: 0;
        border: 0;
        svg {
            fill: white !important;
        }
        :hover{
            background: #42526E;
        }
        :active{
            background: #637498;
        }
    }
}

.patent-view-app__not-found {
    height: calc(100vh - 65px);
}
</style>
